import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import warehouseComponent from "@/components/warehouse/WarehouseComponent.vue";
import { stockReservationTypes } from "@/js/lists.ts";
export default {
  name: "WarehousePopin",
  data: function data(_this) {
    var _this$isInboundForced;
    return {
      dialog: false,
      resolve: null,
      reject: null,
      isEdit: false,
      warehouse: {
        id_warehouse: null,
        name: "",
        mail: "",
        isInboundCompatible: (_this$isInboundForced = _this.isInboundForced) !== null && _this$isInboundForced !== void 0 ? _this$isInboundForced : false,
        isPreventInvoice: false,
        address: {
          id_address: "",
          street: "",
          address_line_2: null,
          address_line_3: null,
          address_complement: null,
          zip: "",
          city: "",
          state: "",
          country: ""
        },
        availableDestinations: []
      },
      default_stock_reservation_type: stockReservationTypes.DEFAULT.id,
      default_stock_reservation_user_id: null
    };
  },
  components: {
    warehouse: warehouseComponent
  },
  props: ["loggedUserData", "stockType", "listCountries", "listStates", "isInboundForced"],
  methods: {
    open: function open() {
      var _this2 = this;
      this.dialog = true;
      return new Promise(function (resolve, reject) {
        _this2.resolve = resolve;
        _this2.reject = reject;
      });
    },
    openEdit: function openEdit(item) {
      var _this3 = this;
      this.dialog = true;
      this.isEdit = true;
      this.warehouse = _objectSpread({}, item);
      return new Promise(function (resolve, reject) {
        _this3.resolve = resolve;
        _this3.reject = reject;
      });
    },
    agree: function agree(data) {
      this.resolve(true);
      this.dialog = false;
      this.$emit("closed", {
        confirmed: true,
        data: data
      });
    },
    cancel: function cancel() {
      this.resolve(false);
      this.dialog = false;
      this.$emit("closed", false);
    }
  }
};